const STEP = {
  BUDGET: 0,
  EMAIL: 1,
};

export default STEP;
